//state
const state = {
	menus: [],
	previledgeMenus: [],
	session: null
}

// getters
const getters = {
	getMenus(state) {
		return state.menus;
	},
	getPreviledgeMenus(state) {
		return state.previledgeMenus;
	},
	getSession(state) {
		return state.session;
	}
}

// actions
const actions = {}

// mutations
const mutations = {
	setMenus(state, menus) {
		state.menus = menus;
	},
	addMenu(state, menu) {
		state.menus.push(menu);
	},
	setSession(state, session) {
		state.session = session;
	},
	setPreviledgeMenus(state, menu) {
		state.previledgeMenus = menu;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
